export default () => {
  if (!process.client) return;

  window.onNuxtReady(() => {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);

    window.addEventListener('resize', () => {
      document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
    });
  });
};
